module.exports = __webpack_public_path__ + "static/media/embody_A0_Rectangle_50_pattern@2x.0298b563.png";